import { render, staticRenderFns } from "./BuilderDetailConfig.vue?vue&type=template&id=2fd55e0a"
import script from "./BuilderDetailConfig.vue?vue&type=script&lang=js"
export * from "./BuilderDetailConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports